import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'

const UserButton = () => {
  const { displayName } = useSelector((state) => state.firebase.auth)

  return (
    <button type='button' className='btn btn-default' data-toggle='modal' data-target='#myModal'>
      {displayName ? (
        <>
          <FontAwesomeIcon icon='user' />
          {` ${displayName}`}
        </>
      ) : (
        <>
          <FontAwesomeIcon icon='sign-in' />
          {' Sign in'}
        </>
      )}
    </button>
  )
}

export default UserButton
